import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../Common/Modal';
import {
  HowToPlayContentEN,
  HowToPlayContentES,
  HowToPlayContentRU,
  HowToPlayContentRO,
  HowToPlayContentPT
} from './content';

interface HowToPlayModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const HowToPlayModal: React.FC<HowToPlayModalProps> = ({ isOpen, onClose }) => {
  const { t, i18n } = useTranslation();
  
  const getContentComponent = () => {
    switch (i18n.language) {
      case 'es': return <HowToPlayContentES />;
      case 'ru': return <HowToPlayContentRU />;
      case 'ro': return <HowToPlayContentRO />;
      case 'pt': return <HowToPlayContentPT />;
      default: return <HowToPlayContentEN />;
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('howToPlay.title')}
    >
      {getContentComponent()}

      <button 
        onClick={onClose}
        className="w-full mt-6 bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-6 rounded-2xl transition-colors"
      >
        {t('howToPlay.gotIt')}
      </button>
    </Modal>
  );
};

export default HowToPlayModal;